export interface AIAdvice {
    mainText: string;
    subText: string;
}

export const MOCK_AI_ADVICE: AIAdvice[] = [
    {
        "mainText": "It looks like you have kids but no life insurance.",
        "subText": "As the main earner, if you die or become disabled it will have a very serious financial impact on your family."
    },
    {
        "mainText": "Your emergency fund is below recommended levels.",
        "subText": "You currently have coverage for 1 month. Financial experts recommend saving 3-6 months of expenses to handle unexpected job loss."
    },
    {
        "mainText": "You are paying high interest on credit card debt.",
        "subText": "Paying only the minimum balance increases your total cost significantly. Consider consolidating this debt to a lower rate."
    }
];
